<template>
  <div
    style="
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-rows: min-content auto;
    "
  >
    <v-row style="width: 100%">
      <template v-for="(item, index) in cards">
        <v-col :cols="item.cols" :key="`home${index}`" style="height: 90vh">
          <component :is="item.component" />
        </v-col>
      </template>
    </v-row>

    <v-snackbar
      v-model="error"
      color="error"
      class="d-flex my-4"
      timeout="10000"
      rounded="10"
    >
      <v-row align="center">
        <v-icon class="mx-3">mdi-alert</v-icon>
        {{ errorMessage }}
        <v-spacer />
        <v-btn icon @click="setErrorMessage(null)">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-row>
    </v-snackbar>

    <v-dialog max-width="400" v-model="loading">
      <v-card class="rounded-xl">
        <v-card-text class="text-center pa-10">
          <LoadingSpinner />
        </v-card-text>
      </v-card>
    </v-dialog>

    <AdminConsole v-if="isEmployee" @open="openSession" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import * as NCFrontend from "@osteon-nexus-connect-lib/nc-frontend"
import oftClient from "@/lib/OftApi"
import MainCard from "./HomePage/MainCard.vue"
import SuggestedSolutions from "./HomePage/SuggestedSolutions.vue"
import ConnectBranding from "./HomePage/ConnectBranding.vue"
import SelectionDivs from "./HomePage/SelectionDivs.vue"
import ValidatedDiv from "./HomePage/ValidatedDiv.vue"
import AdminConsole from "./HomePage/AdminConsole.vue"
import LoadingSpinner from "@/components/shared/LoadingSpinner.vue"
import AssociationDiv from "./HomePage/AssociationDiv.vue"

export default {
  name: "HomePage",

  data() {
    return {
      loading: false
    }
  },

  components: {
    MainCard,
    SuggestedSolutions,
    ConnectBranding,
    SelectionDivs,
    ValidatedDiv,
    AdminConsole,
    LoadingSpinner,
    AssociationDiv
  },

  computed: {
    ...mapGetters([
      "pageState",
      "settings",
      "client",
      "errorMessage",
      "isEmployee"
    ]),

    cards() {
      const remainingCols = this.pageState.reduce((acc, val) => {
        return acc - val.cols
      }, 12)
      const cards = [{ cols: remainingCols, component: "MainCard" }]

      cards.push(...this.pageState)

      return cards
    },

    error: {
      get() {
        return !!this.errorMessage
      },
      set(value) {
        if (!value) this.setErrorMessage(null)
      }
    }
  },

  methods: {
    ...mapActions([
      "setErrorMessage",
      "setNCSessionID",
      "setKitBoxID",
      "setSessionType",
      "setPageState",
      "setAnalyzerSession",
      "setValidateScansResponse",
      "setStepIndex",
      "setLibraryAssociationResponse",
      "setSelectedGaugeIndex",
      "setLibraryAssociationEnabled",
      "setValidatedScanFiles"
    ]),

    async openSession(session) {
      this.loading = true

      this.setStepIndex(1)

      this.setNCSessionID(session.nc_session_id)
      if (session.kit_serial_number) {
        const kitResponse = await this.$axios.get(
          `/proxy/scan_gauge_kit/${session.kit_serial_number}/`
        )
        this.setKitBoxID(kitResponse.data)
      }
      this.setSessionType(session.session_type.toLowerCase())
      this.setAnalyzerSession(session)
      this.setLibraryAssociationEnabled(false)
      this.setSelectedGaugeIndex(-1)

      const response = await NCFrontend.ApiClient.sessionGet(
        "/proxy",
        "",
        session.nc_session_id
      )
      this.setValidateScansResponse(response)
      if (response.libraryAssociation)
        this.setLibraryAssociationResponse(response.libraryAssociation)
      else this.setLibraryAssociationResponse(null)

      if (
        response.fixedScan?.originalFileOftUid &&
        response.movingScan?.originalFileOftUid
      ) {
        const files = [
          {
            oftUid: response.fixedScan.originalFileOftUid
          },
          {
            oftUid: response.movingScan.originalFileOftUid
          }
        ]
        await oftClient.getFileUrls(files)
        this.setValidatedScanFiles(files)
      } else {
        this.setValidatedScanFiles(null)
      }

      this.setPageState([{ cols: 7, component: "ValidatedDiv" }])
      this.setStepIndex(3)

      this.loading = false
    }
  }
}
</script>
